import { render } from "./leaves-definitions.vue?vue&type=template&id=26c0c8ab"
import script from "./leaves-definitions.vue?vue&type=script&lang=js"
export * from "./leaves-definitions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__